import Navbar from "./components/Navbar";
import PuzzleHero from "./components/PuzzleHero";

export default function Home() {
  return (
    <main className="relative w-full min-h-screen bg-white text-stone-800">
      <Navbar />
      <PuzzleHero />
    </main>
  );
}